<script setup lang='ts'>
import { imageTransform, loginPath } from '@qcwp/common'
import { NO_LOGIN_TEXT } from '~~/src/common/const'
import { useAuth } from '~~/src/store'
const props = withDefaults(defineProps<{
  articleId: string
}>(), {})

// 用户登录状态
const authStore = useAuth()
const { IS_LOGIN, USER_HEAD, USER_NAME } = authStore
</script>

<template>
  <div>
    <h1 text-5 font-bold mb-3>
      评论
    </h1>
    <div class="flex items-start ">
      <utils-avatar
        class="mr-2 flex-shrink-0"
        round size="large"
        :src="imageTransform(USER_HEAD, { format: 'webp' })"
        :name="IS_LOGIN ? USER_NAME?.slice(0, 1) : NO_LOGIN_TEXT"
        :color="IS_LOGIN ? 'var(--color-primary)' : 'var(--color-default)'"
      />

      <div v-if="IS_LOGIN" flex-grow w-0>
        <layout-comment-input :article-id="props.articleId" />
      </div>
      <NuxtLink
        v-else
        target="_blank" no-rel :to="loginPath()"
        class="bg-gray-100 flex-grow h-20 rounded-md grid place-items-center"
      >
        <p>
          看完啦，<span class="text-primary">
            登录
          </span>分享一下感受吧～
        </p>
      </NuxtLink>
    </div>
  </div>
</template>
